/* eslint-disable */

// breakUrls.js
const breakUrls = {

  init() {
    const $instances = document.querySelectorAll('a[href^="http"],a[href^="www"]');
    Array.prototype.forEach.call($instances, ($instance) => {
      // allow long url's in text to break
      if ($instance.innerHTML === $instance.href) {
        $instance.innerHTML = `<span style="word-break:break-all;">${$instance.innerHTML}</span>`;
      }
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  breakUrls.init();
});
// end breakUrls.js

/* eslint-enable */
